import { newToast } from '../components';
import { SysI_Agenda, SysI_AgendaCitas, SysI_AgendaCitasExtendido, FiltroCitas } from '../types/types.agendaCitas';
import useApi from '../utils/axios-pettitions';

export const useApiAppointments = () => {
  const { runApi } = useApi();

  // Endpoints para Agendas
  const getAgendas = async () => {
    return runApi('Appointments/GetAgendas', 'GET', null, null).then((res) => {
      if (res.internalCode >= 200) {        
        return [];
      } else if (res.internalCode === 101) {
        return res.data as SysI_Agenda[];
      }
      return [];
    });
  };

  const getAgendaById = async (id: number) => {
    return runApi(`Appointments/GetAgendaById?id=${id}`, 'GET', null, null).then((res) => {
      if (res.internalCode >= 200) {        
        return null;
      } else if (res.internalCode === 101) {
        return res.data as SysI_Agenda;
      }
      return null;
    });
  };

  const getAgendasByUser = async (userId: number) => {
    return runApi(`Appointments/GetAgendasByUser?userId=${userId}`, 'GET', null, null).then((res) => {
      if (res.internalCode >= 200) {        
        return [];
      } else if (res.internalCode === 101) {
        return res.data as SysI_Agenda[];
      }
      return [];
    });
  };

  const createAgenda = async (agenda: SysI_Agenda) => {
    return runApi('Appointments/CreateAgenda', 'POST', null, agenda).then((res) => {
      if (res.internalCode === 105) {
        newToast('SUCCESS', 'Agenda creada correctamente', 5);
        return res.data as number;
      } else {        
        throw new Error('Error al crear agenda');
      }
    });
  };

  const updateAgenda = async (agenda: SysI_Agenda) => {
    return runApi('Appointments/UpdateAgenda', 'POST', null, agenda).then((res) => {
      if (res.internalCode === 107) {
        newToast('SUCCESS', 'Agenda actualizada correctamente', 5);
        return true;
      } else {        
        throw new Error('Error al actualizar agenda');
      }
    });
  };

  const updateCitaPreorden = async (citaId: number, preorderId: number) => {
    const requestData = {
      CitaId: citaId,
      PreorderId: preorderId,
    };

    return runApi('Appointments/UpdateCitaPreorden', 'POST', null, requestData).then((res) => {
      if (res.internalCode === 107) {
        return true;
      } else {        
        throw new Error('Error al actualizar cita con preorden');
      }
    });
  };

  const deleteAgenda = async (id) => {
    return runApi('Appointments/DeleteAgenda', 'POST', { id: id }, null).then((res) => {
      if (res.internalCode === 108) {
        newToast('SUCCESS', 'Agenda eliminada correctamente', 5);
        return true;
      } else {        
        throw new Error('Error al eliminar agenda');
      }
    });
  };

  // Endpoints para Citas
  const getAllCitas = async () => {
    return runApi('Appointments/GetCitas', 'GET', null, null).then((res) => {
      if (res.internalCode >= 200) {        
        return [];
      } else if (res.internalCode === 101) {
        return res.data as SysI_AgendaCitasExtendido[];
      }
      return [];
    });
  };

  const getCitaById = async (id: number) => {
    return runApi(`Appointments/GetCitaById?id=${id}`, 'GET', null, null).then((res) => {
      if (res.internalCode >= 200) {        
        return null;
      } else if (res.internalCode === 101) {
        return res.data as SysI_AgendaCitasExtendido;
      }
      return null;
    });
  };

  const getCitasByAgenda = async (data: any) => {
    return runApi(`Appointments/GetCitasByAgenda`, 'POST', null, data ).then((res) => {
      if (res.internalCode >= 200) {        
        return [];
      } else if (res.internalCode === 101) {
        return res.data as SysI_AgendaCitasExtendido[];
      }
      return [];
    });
  };

  const getCitasByPaciente = async (pacienteId: number) => {
    return runApi(`Appointments/GetCitasByPaciente?pacienteId=${pacienteId}`, 'GET', null, null).then((res) => {
      if (res.internalCode >= 200) {        
        return [];
      } else if (res.internalCode === 101) {
        return res.data as SysI_AgendaCitasExtendido[];
      }
      return [];
    });
  };

  const getCitasByUsuario = async (userId: number) => {
    return runApi(`Appointments/GetCitasByUsuario?userId=${userId}`, 'GET', null, null).then((res) => {
      if (res.internalCode >= 200) {        
        return [];
      } else if (res.internalCode === 101) {
        return res.data as SysI_AgendaCitasExtendido[];
      }
      return [];
    });
  };

  const getCitasByRango = async (startDate: Date | string, endDate: Date | string) => {
    return runApi(`Appointments/GetCitasByRango?startDate=${startDate}&endDate=${endDate}`, 'GET', null, null).then((res) => {
      if (res.internalCode >= 200) {        
        return [];
      } else if (res.internalCode === 101) {
        return res.data as SysI_AgendaCitasExtendido[];
      }
      return [];
    });
  };

  const createCita = async (cita: SysI_AgendaCitas) => {
    return runApi('Appointments/CreateCita', 'POST', null, cita).then((res) => {
      if (res.internalCode === 105) {
        newToast('SUCCESS', 'Cita creada correctamente', 5);
        return res.data as number;
      } else {        
      }
    });
  };

  const updateCita = async (cita: SysI_AgendaCitas) => {
    return runApi('Appointments/UpdateCita', 'POST', null, cita).then((res) => {
      if (res.internalCode === 107) {
        newToast('SUCCESS', 'Cita actualizada correctamente', 5);
        return true;
      } else {        
        throw new Error('Error al actualizar cita');
      }
    });
  };

  const cancelCita = async (id: number) => {
    return runApi('Appointments/CancelCita', 'POST', null, { id }).then((res) => {
      if (res.internalCode === 108) {
        newToast('SUCCESS', 'Cita cancelada correctamente', 5);
        return true;
      } else {        
        throw new Error('Error al cancelar cita');
      }
    });
  };

  const isTimeSlotAvailable = async (agendaId: number, appointmentTime: Date | string, excludeCitaId?: number) => {
    let url = `Appointments/IsTimeSlotAvailable?agendaId=${agendaId}&appointmentTime=${appointmentTime}`;
    if (excludeCitaId) {
      url += `&excludeCitaId=${excludeCitaId}`;
    }

    return runApi(url, 'GET', null, null).then((res) => {
      if (res.internalCode >= 200) {        
        return false;
      } else if (res.internalCode === 101) {
        return res.data as boolean;
      }
      return false;
    });
  };

  // Función para filtrar citas con múltiples criterios
  const filtrarCitas = async (filtro: FiltroCitas) => {
    // Si tenemos un userId, obtenemos primero las citas por usuario
    if (filtro.userId) {
      return getCitasByUsuario(filtro.userId).then((citas) => {
        // Aplicamos los demás filtros en memoria
        let citasFiltradas = [...citas];

        if (filtro.agendaId) {
          citasFiltradas = citasFiltradas.filter((c) => c.Ct_Ag_Id === filtro.agendaId);
        }

        if (filtro.pacienteId) {
          citasFiltradas = citasFiltradas.filter((c) => c.Ct_Pa_Id === filtro.pacienteId);
        }

        if (filtro.fechaInicio && filtro.fechaFin) {
          const inicio = new Date(filtro.fechaInicio);
          const fin = new Date(filtro.fechaFin);

          citasFiltradas = citasFiltradas.filter((c) => {
            const fechaCita = new Date(c.Ct_FechaAtencion);
            return fechaCita >= inicio && fechaCita <= fin;
          });
        }

        return citasFiltradas;
      });
    }
    // Si tenemos fechas, filtramos por rango
    else if (filtro.fechaInicio && filtro.fechaFin) {
      return getCitasByRango(filtro.fechaInicio, filtro.fechaFin).then((citas) => {
        let citasFiltradas = [...citas];

        if (filtro.agendaId) {
          citasFiltradas = citasFiltradas.filter((c) => c.Ct_Ag_Id === filtro.agendaId);
        }

        if (filtro.pacienteId) {
          citasFiltradas = citasFiltradas.filter((c) => c.Ct_Pa_Id === filtro.pacienteId);
        }

        return citasFiltradas;
      });
    }
    // Si solo tenemos agendaId, filtramos por agenda
    else if (filtro.agendaId) {
      alert('Filtrando por agenda');
      return getCitasByAgenda([filtro.agendaId]).then((citas) => {
        let citasFiltradas = [...citas];

        if (filtro.pacienteId) {
          citasFiltradas = citasFiltradas.filter((c) => c.Ct_Pa_Id === filtro.pacienteId);
        }

        return citasFiltradas;
      });
    }
    // Si solo tenemos pacienteId, filtramos por paciente
    else if (filtro.pacienteId) {
      return getCitasByPaciente(filtro.pacienteId);
    }
    // Sin filtros, obtenemos todas las citas
    else {
      return getAllCitas();
    }
  };

  return {
    // Métodos para agendas
    getAgendas,
    getAgendaById,
    getAgendasByUser,
    createAgenda,
    updateAgenda,
    updateCitaPreorden,
    deleteAgenda,

    // Métodos para citas
    getAllCitas,
    getCitaById,
    getCitasByAgenda,
    getCitasByPaciente,
    getCitasByUsuario,
    getCitasByRango,
    createCita,
    updateCita,
    cancelCita,
    isTimeSlotAvailable,

    // Método compuesto
    filtrarCitas,
  };
};
